import { Account } from "../models/account";
import BaseService from "./_base.service";

const endpoint = "accounts";

const AccountsService = {
  ...BaseService<Account>({ endpoint }),
};

export default AccountsService;
